// extracted by mini-css-extract-plugin
export default {"wrapper":"Seed_wrapper__-YJ4k","isActive":"Seed_isActive__Ji3uc","content":"Seed_content__cxBwf","soon":"Seed_soon__bvXYV"};